<template>
    <nav class="navbar sticky-top navbar-expand-md navbar-dark bg-dark">
        <a class="navbar-brand" href="#">Nova API * Backoffice</a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <router-link to="/artists" active-class="active" class="nav-link">Artists</router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/albums" active-class="active" class="nav-link">Albums</router-link>
                </li>  
                <li class="nav-item">
                    <router-link to="/lyrics" active-class="active" class="nav-link">Lyrics</router-link>
                </li>  
                <li class="nav-item">
                    <router-link to="/logs" active-class="active" class="nav-link">Logs</router-link>
                </li>               
                <li class="nav-item">
                    <router-link to="/status" active-class="active" class="nav-link">Status</router-link>
                </li>               
            </ul>            
        </div>
    </nav>
</template>

<script>
    export default {
        name: 'navigation',
        methods: {            
        }
    }
</script>
